import { useNosIdQuery } from '@/hooks/api/base.hooks';
import { api } from '@/portal-api.definition';
import { ImageProfile, mage } from '@nosinovacao/nosid-mfe-common';
import { queryOptions } from '@tanstack/react-query';

export const getApplicationsQueryOptions = queryOptions({
  queryKey: ['applications'],
  queryFn: () =>
    api
      .get('/api/v1/applications')
      .then((apps) =>
        apps.map((app) => ({ ...app, LogoUrl: mage.getImage(app.LogoUrl, ImageProfile.App) })),
      ),
});

export function useGetApplications() {
  return useNosIdQuery(getApplicationsQueryOptions);
}
